import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../views/HomePage.vue'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: '/index/HomePage',
        },

        //手机端扫描查看证书结果
        {
            path: '/index/CertQueryMobile',
            name: 'CertQueryMobile',
            component: () => import('../views/certView/CertQueryMobile.vue')
        },

        {
            path: '/index',
            name: 'index',
            component: () => import('../views/Index.vue'),
            children: [
                //首页
                {
                    path: '/index/HomePage',
                    name: 'HomePage',
                    component: () => import('../views/HomePage.vue'),
                },
                // 中心概况
                {
                    path: '/index/AboutUsList',
                    name: 'AboutUsList',
                    component: () => import('../views/aboutUsView/AboutUsList.vue'),
                },
                // 新闻动态
                {
                    path: '/index/DynamicList',
                    name: 'DynamicList',
                    component: () => import('../views/dynamicView/DynamicList.vue'),
                },
                //培训信息
                {
                    path: '/index/TrainList',
                    name: 'TrainList',
                    component: () => import('../views/trainView/TrainList.vue'),
                },
                //成果展示
                {
                    path: '/index/ActivityList',
                    name: 'ActivityList',
                    component: () => import('../views/activityView/ActivityList.vue'),
                },
                //专题培训
                {
                    path: '/index/ProjectList',
                    name: 'ProjectList',
                    component: () => import('../views/projectView/ProjectList.vue'),
                },
                 //其他
                 {
                    path: '/index/HeatingList',
                    name: 'HeatingList',
                    component: () => import('../views/heatingView/HeatingList.vue'),
                },
                //资料下载
                {
                    path: '/index/MaterialList',
                    name: 'MaterialList',
                    component: () => import('../views/materialView/MaterialList.vue'),
                },
                //证书查询
                {
                    path: '/index/CertSearch',
                    name: 'CertSearch',
                    component: () => import('../views/certView/CertSearch.vue')
                },
                {
                    path: '/index/CertQuery',
                    name: 'CertQuery',
                    component: () => import('../views/certQueryView/CertQuery.vue')
                },
                //新闻详情
                {
                    path: '/index/NewsDetail',
                    name: 'NewsDetail',
                    component: () => import('../views/NewsDetail.vue'),
                },


            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js